import colors from "../../base/colors";
import pxToRem from "../../functions/pxToRem";

const { primary, inputBorderColor, dark, grey, error } = colors;

const input = {
  styleOverrides: {
    root: {
      fontSize: pxToRem(14),
      color: dark.main,

      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `1px solid ${grey[500]}`,
      },

      "&:before": {
        borderColor: inputBorderColor,
        transition: "border-bottom-color 0.12s ease",
      },

      "&:after": {
        borderColor: primary.main,
        borderWidth: "2px",
      },

      "&.Mui-error": {
        "&:after": {
          borderColor: error.main,
        },
      },
    },

    input: {
      color: dark.main,
      padding: `${pxToRem(6)} 0`,
      fontSize: pxToRem(14),
      lineHeight: "20px",

      "&::placeholder": {
        color: grey[500],
        opacity: 1,
      },

      "&:focus": {
        outline: "none",
      },
    },

    inputSizeSmall: {
      padding: `${pxToRem(6)} 0`,
      fontSize: pxToRem(14),
    },
  },
};

export default input;
